import SET_USER from './types';
export default {
  [SET_USER](state, payload) {
    const currentState = state;
    currentState.user = payload;
  }

};